import { Injectable } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

const i18nDefault = {};

@Injectable()
export class TotvsTranslateProvider {

    constructor(
        private _translateNgx: TranslateService,
        private http: Http
    ) {
    }

    private i18n: any = i18nDefault;
    private language: string;

    //PUBLICOS
    public initialize(_language: string, _component: string) {

        if (null != _language && undefined != _language && "" != _language)
            this.language = _language
        else
            this.language = this._translateNgx.currentLang.substring(0, 2);

        this.getJSONDataAsync("../../assets/i18n/" + _component + "/pt.json").then(data => {
            this.i18n[_component]["pt"] = data
            return this.getJSONDataAsync("../assets/i18n/" + _component + "/es.json");
        }).then(data => {
            this.i18n[_component]["es"] = data
            return this.getJSONDataAsync("../assets/i18n/" + _component + "/en.json");
        }).then(data => {
            this. i18n[_component]["en"] = data
        });

    };

    public instant(message: string, _component: string) {
        return this.findMessage(message, _component);
    };

    public get(keys: string | Array<string>, _component: string, interpolateParams?: Object) {

        let retorno: any = {};
        let translatedKey: string = "";
        let paramsFromTranslatedKey: string = "";

        if (!(typeof keys === 'string')) {
            for (let key in <Array<string>>keys) {
                translatedKey = this.instant(keys[key], _component);
                paramsFromTranslatedKey = this.getFromBetween.get(translatedKey, "{{", "}}");
                translatedKey = this.fillParameters(paramsFromTranslatedKey, translatedKey, _component, interpolateParams)
                retorno[keys[key]] = translatedKey;
            }

            return retorno;

        } else {
            translatedKey = this.instant(String(keys), _component);
            paramsFromTranslatedKey = this.getFromBetween.get(translatedKey, "{{", "}}");
            translatedKey = this.fillParameters(paramsFromTranslatedKey, translatedKey, _component, interpolateParams)

            return translatedKey;
        }

    };

    //PRIVADOS
    private findMessage(_message: string, _component: string) {

        //let language: string = this._translateNgx.currentLang.substring(0, 2);
        try {
            if (undefined != this.i18n && null != this.i18n) {

                let msg: any = this.i18n[_component][this.language];

                let split: any = String(_message).split(".")

                for (let m in split) {
                    if (undefined != msg[split[m]] && null != msg[split[m]])
                        msg = msg[split[m]];
                    else
                        msg = _message;
                }

                return msg
            }
        }
        catch (e) {
            return _message
        }

    };

    private getFromBetween = {
        results: [],
        string: "",
        getFromBetween: function (sub1, sub2) {
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
            var SP = this.string.indexOf(sub1) + sub1.length;
            var string1 = this.string.substr(0, SP);
            var string2 = this.string.substr(SP);
            var TP = string1.length + string2.indexOf(sub2);
            return this.string.substring(SP, TP);
        },
        removeFromBetween: function (sub1, sub2) {
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
            var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
            this.string = this.string.replace(removal, "");
        },
        getAllResults: function (sub1, sub2) {
            // first check to see if we do have both substrings
            if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

            // find one result
            var result = this.getFromBetween(sub1, sub2);
            // push it to the results array
            this.results.push(result);
            // remove the most recently found one from the string
            this.removeFromBetween(sub1, sub2);

            // if there's more substrings
            if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
                this.getAllResults(sub1, sub2);
            }
            else return;
        },
        get: function (string, sub1, sub2) {
            this.results = [];
            this.string = string;
            this.getAllResults(sub1, sub2);
            return this.results;
        }
    };

    private fillParameters(paramsFromTranslatedKey: string, translatedKey: string, component: string, interpolateParams?: Object) {

        for (let paramFromTranslatedKey of paramsFromTranslatedKey) {

            let valueFromParamFromTranslatedKey: string = paramFromTranslatedKey;

            if (null != interpolateParams && undefined != interpolateParams && interpolateParams.hasOwnProperty(paramFromTranslatedKey))
                valueFromParamFromTranslatedKey = interpolateParams[paramFromTranslatedKey];

            translatedKey = translatedKey.replace("{{" + paramFromTranslatedKey + "}}", this.instant(valueFromParamFromTranslatedKey, component));

        }

        return translatedKey;
    };

    private getJSONDataAsync(filePath: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(filePath)
                .subscribe(
                    res => {
                        if (!res.ok) {
                            reject("Failed with status: " + res.status + "\nTrying to find fil at " + filePath);
                        }

                        var jsonRes = res.json();

                        resolve(jsonRes);
                    }
                );
        }).catch((reason) => this.handleError(reason));
    }

    /* Takes an error, logs it to the console, and throws it */
    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}